+function($, document) {
	var scope;
	
	var AjaxMask = function(element, options) {
		this.$element = $(element);
		this.$body = $(document.body);
		this.options = options;
		
		this.initialize();
	};
	
	AjaxMask.DEFAULTS = {
	};
	
	AjaxMask.prototype.initialize = function() {
		scope = this;
		
		this.$element.parent().css('position', 'relative');
		
		$.subscribe('showajaxmask.sn', function() {
			scope.$element.show();
		});
		
		$.subscribe('hideajaxmask.sn', function() {
			scope.$element.hide();
		});
	};
	
	function Plugin(option) {
		var $this   = $(this),
			data   	= $this.data('sn.AjaxMask'),
			options = $.extend({}, AjaxMask.DEFAULTS, typeof option == 'object' && option);
		  
		if ( ! data) {
			$this.data('sn.AjaxMask', (data = new AjaxMask(this, options)));  
		} 
		  
		if (typeof option == 'string') {
			data[option]();  
		} 
	}

	var old = $.fn.ajaxMask;
	
	$.fn.ajaxMask = Plugin;
	$.fn.ajaxMask.Constructor = AjaxMask;
	
	$.fn.ajaxMask.noConflict = function () {
	    $.fn.ajaxMask = old;
	    return this;
	};
	
	//data-api
	$(function() {
		$('[data-toggle="ajaxmask"]').each(function () {
			var $element = $(this);
		  
			Plugin.call($element, $element.data())
		});
	})
}(jQuery, document);